import { gql } from '@apollo/client';

export default gql`
  mutation deleteSalaryPayment($_id: String) {
    deleteSalaryPayment(_id: $_id) {
      ok
      message
      error
    }
  }
`;
